import { isEmpty } from '@ember/utils';
import BaseRESTSerializer from '@square/dashboard-data/serializers/base-rest-serializer';
function removeDuplicatesByKey(arr = [], keyAttrName = 'token') {
  const seenKeys = new Set();
  return arr.filter(el => {
    const key = el[keyAttrName];
    if (!key) {
      // if the key does not exist on the item, do not try and deduplicate this item.
      return true;
    }
    const isDuplicate = seenKeys.has(key);
    seenKeys.add(key);
    return !isDuplicate;
  });
}
export default BaseRESTSerializer.extend({
  primaryKey: 'token',
  modelName: 'squareup/inventory/v3/vendor',
  collectionKey: 'vendors',
  rootKey: 'vendor',
  serialize(snapshot, options) {
    const json = this._super(snapshot, options);

    // https://jira.sqprod.co/browse/ONCALL-149179
    if (!isEmpty(json.contacts)) {
      // Vendors should not have multiple instances of the same contact on the contacts array.
      json.contacts = removeDuplicatesByKey(json.contacts);
    }
    return json;
  },
  serializeAttribute(snapshot, json, key, attributes) {
    // Ember data coerces undefined values to null, but some APIs treat
    // those values differently.
    if (snapshot.attr(key) === undefined) {
      return;
    }
    this._super(snapshot, json, key, attributes);
  },
  serializeIntoHash(data, type, snapshot, options) {
    Object.assign(data, this.serialize(snapshot, options));
    snapshot.record.set('contacts', snapshot.record.contacts.filter(contact => contact?.removed !== true));
  },
  normalizeSaveResponse(store, type, payload, id, requestType) {
    return this._super(store, type, {
      [this.rootKey]: payload
    }, payload[this.primaryKey], requestType);
  }
});